
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import NeuriteGrid from '../../components/neurite_grid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

//actions:
import { navigate, openDialog, hideDialog } from '../../actions';
import { getZonasCentro, modifyZonaCentro } from '../../actions/zonas_centro_actions';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        dispay: 'block'
    },
    bottomBtn: {
        position: 'absolute',
        right: '0',
        bottom: '0',
        margin: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeZona extends Component {


    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        if (this.props.centroId === -1) {

            this.props.getZonasCentro(this.props.centroDiaSelected.centro.isGroup ?
                this.props.centros.filter(c => c.isGroup === false && c.activo === 1)[0].id
                : this.props.centroDiaSelected.centro.id);
        }
        else {
            this.props.getZonasCentro(this.props.centroId);
        }

    };


    handleChangeSelect = event => {

        this.props.getZonasCentro(event.target.value ? event.target.value : 1);
    };


    centroSelectList = () => {

        return this.props.centros.filter(c => c.isGroup === false && c.activo === 1).map((centro, index) => {
            return (
                <option key={centro.id} value={centro.id}>{centro.centro}</option>
            );
        })
    };


    editZona = (zona) => {
        this.props.navigate("edit_zona/" + zona.id);
    };


    render() {

        const { classes } = this.props;



        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />

                {this.props.centros && this.props.kd === undefined ?
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="mae-zona-placeholder">
                            Centro
                            </InputLabel>
                        <Select
                            native
                            value={this.props.centroId}
                            onChange={(event) => this.handleChangeSelect(event)}
                        >
                            {this.centroSelectList()}
                        </Select>
                    </FormControl>
                    : ''}
                <NeuriteGrid
                    id="m_z"
                    columns={[
                        { key: 'descr', name: 'Descripción', editable: true, dragable: false, width: 100, },
                        { key: 'tipoZona', name: 'Tipo Zona', editable: true, dragable: false, width: 100, },
                        { key: 'activo', name: 'Activo', type: 'bool', dragable: false, width: 55, },
                    ]}
                    rows={this.props.zonas}
                    buttonEdit={true}
                    buttonDelete={false}
                    buttonNew={false}
                    onEditClick={this.editZona}
                    onDeleteClick={this.deleteZona}

                />
            </div>
        );

    };

};

MaeZona.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    zonas: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    centroId: PropTypes.number.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getZonasCentro: PropTypes.func.isRequired,
    modifyZonaCentro: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        zonas: state.zonasCentro.zonas,
        isLoading: state.zonasCentro.isLoading,
        centroId: state.zonasCentro.centroId,
        centroDiaSelected: state.centroDiaSelected,
        kd : state.userProfile.kd,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getZonasCentro,
        modifyZonaCentro,
        openDialog,
        hideDialog,
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MaeZona));
